import { LinksSectionGroup } from "@components/common/LinksSection";
import {
  City,
  Country,
  SupplierFiltersResponse,
  TourFiltersResponse,
} from "@graphql/types";
import { useRouter } from "next/router";
import React, { FC } from "react";
import { getFiltersLinksSections } from "./utils/getFiltersLinksSections";
import { getLocationLinks } from "@components/common/SEO/utils/getLocationLinks";

interface SearchLinksSectionProps {
  location: string;
  productType: string;
  filters: TourFiltersResponse | SupplierFiltersResponse;
  city?: City;
  country?: Country;
}

export const SearchLinksSection: FC<SearchLinksSectionProps> = ({
  location,
  productType,
  filters,
  city,
  country,
}) => {
  const router = useRouter();

  if (router.query.q) {
    return null;
  }

  return (
    <div className="mt-20">
      <LinksSectionGroup
        title={`More ${productType} in ${location}`}
        links={[
          ...getFiltersLinksSections({
            filters,
            query: router.query,
          }),
          {
            title: `More About ${location}`,
            links: getLocationLinks(country, city),
          },
        ]}
      />
    </div>
  );
};
